import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  TextField,
  Button,
} from "@material-ui/core";
import { AlertaModalV2 } from "../AlertaSwall";
import { subtareasApi } from "src/services/subtareasApi";
import { useSnackbar } from "src/components/snackbar";

export default function AgregarSubTareaDialog(props) {
  const { open, setOpen, tarea } = props;
  const [agregarSubtarea] = subtareasApi.useAddSubtareaMutation();
  const [nombreSubTarea, setNombreSubTarea] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    setOpen(false);
  };

  const agregar = () => {
    AlertaModalV2({
      title: "¿crear la subtarea?",
      text: "Se agregara una nueva subtarea",
      confirmButtonText: "Sí, crear",
      cancelButtonText: "Cancelar",
      icon: "question",
    })
      .fire()
      .then((result) => {
        if (result.isConfirmed) {
          agregarSubtarea({
            nombre: String(nombreSubTarea).toUpperCase(),
            refTarea: tarea.id,
          })
            .unwrap()
            .then(() => {
              enqueueSnackbar("Subtarea creada", {
                variant: "success",
              });
              setOpen(false);
            })
            .catch(() => {
              enqueueSnackbar("Error en el servidor", {
                variant: "error",
              });
            });
        }
      });
  };

  const handleChangeNombreSubTarea = (event) => {
    setNombreSubTarea(event.target.value);
  };

  return (
    <Dialog open={open} id="dialogAgregarSubtarea">
      <DialogTitle>Nueva Subtarea</DialogTitle>
      <DialogContent>
        <Stack style={{ marginTop: "10px" }}>
          <TextField
            value={nombreSubTarea}
            onChange={handleChangeNombreSubTarea}
            label="Nombre Subtarea"
            variant="outlined"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={agregar} autoFocus>
          Agregar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
